import { useEffect } from "react";
import "./sidebar.scss";
import { Link, useLocation } from "react-router-dom";
import {
  InsertDriveFile,
  Storage,
  WatchLater,
  Feedback,
  Description,
  History,
} from "@mui/icons-material";
import { MdLockReset } from "react-icons/md";

function Sidebar({ stateVal, trigger }) {
  const location = useLocation();
  const { pathname } = location;

  // Add resize event listener to handle responsive behavior
  useEffect(() => {
    const handleResize = () => {
      // If screen is wide enough (>= 992px) and sidebar is hidden, show it
      if (window.innerWidth >= 992 && !stateVal) {
        trigger();
      }
      // If screen is too narrow (< 992px) and sidebar is shown, hide it
      else if (window.innerWidth < 992 && stateVal) {
        trigger();
      }
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [stateVal, trigger]);


  const closeSideMenu = () => {
    if (window.innerWidth < 992) {
      trigger();
    }
  };
  return (
    <div className={`sidebar sidebarContainer ${stateVal ? "" : "d-none"}`}>
      <div className="sidebarContent">
        {/* home */}
        {/* <Link
          to="/home"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/home" ? "subContent mb-2 active" : "subContent mb-2"
            }
          >
            <Home className="icon" />
            <p className="actualText">Home</p>
          </div>
        </Link> */}
        {/* Import data */}
        <Link
          to="/import"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/import"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <InsertDriveFile className="icon" />
            <p className="actualText">Import</p>
          </div>
        </Link>

        <Link
          to="/data-processing"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/data-processing"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <Storage className="icon" />
            <p className="actualText">Data Processing</p>
          </div>
        </Link>

        {/* data selection */}
        <Link
          to="/data-selection"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/data-selection"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <WatchLater className="icon" />
            <p className="actualText">Data Selection</p>
          </div>
        </Link>
        {/* /reports */}
        <Link
          to="/reports"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/reports"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <Feedback className="icon" />
            <p className="actualText">Reports</p>
          </div>
        </Link>
        {/* /history */}
        <Link
          to="/history"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/history"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <History className="icon" />
            <p className="actualText">Historical Data</p>
          </div>
        </Link>
        {/* reference data */}
        <Link
          to="/reference-data"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/reference-data"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <InsertDriveFile className="icon" />
            <p className="actualText">Reference Data</p>
          </div>
        </Link>

        {/* Compare */}
        <Link
          to="/delisted-entity"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/delisted-entity"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <Description className="icon" />
            <p className="actualText">Delisted Entity</p>
          </div>
        </Link>
        {/* reset password */}
        <Link
          to="/reset-password"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link"
        >
          <div
            className={
              pathname === "/reset-password"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <MdLockReset className="icon" />
            <p className="actualText">Reset Password</p>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Sidebar;
